import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import Features from './components/Features';
import PackageSelection from './components/PackageSelection';
import PaymentMethods from './components/PaymentMethods';
import PartnersSection from './components/PartnersSection';
import Footer from './components/Footer';

export default function Home() {
  const { t } = useTranslation();
  const [selectedPackage, setSelectedPackage] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <AboutSection />
      <Features />
      <PackageSelection 
        selectedPackage={selectedPackage}
        onSelectPackage={setSelectedPackage}
      />
      <PaymentMethods selectedPackage={selectedPackage} />
      <PartnersSection />
      <Footer />
    </div>
  );
}
